// dependency-graph-ignore-file
// @ts-nocheck -- handler types use any for change shape; to be refined
import { numberFormatMap } from '@databases/collab/convert/to-collab';
import { type Database } from '@databases/model/database';
import { NumberFormat } from '@databases/model/field';

export function setFieldSettingsNumberFormat(
  ydb: Database,
  fieldId: string,
  newValue: any
): void {
  ydb.mutate((db) => {
    const field = db.fieldsById[fieldId];
    const oldFormat = field.numberFormat;
    const newFormat = numberFormatMap[newValue.format];

    field.numberFormat = newFormat;

    const isChangingFromPercent =
      oldFormat === NumberFormat.PERCENT && newFormat !== NumberFormat.PERCENT;
    const isChangingToPercent =
      oldFormat !== NumberFormat.PERCENT && newFormat === NumberFormat.PERCENT;

    if (isChangingFromPercent || isChangingToPercent) {
      for (const entryId in db.entriesById) {
        const entry = db.entriesById[entryId];
        const value = entry.getValue(fieldId);

        if (value && value.value) {
          const currentValue = Number(value.value);
          if (!isNaN(currentValue)) {
            let convertedValue: number;

            if (isChangingFromPercent) {
              convertedValue = parseFloat((currentValue * 100).toFixed(10));
            } else {
              convertedValue = parseFloat((currentValue / 100).toFixed(10));
            }

            (value as any).value = convertedValue.toString();
          }
        }
      }
    }
  });
}
